import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="w-full px-4 md:px-6 py-20 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
          准备好开始探索了吗？
        </h2>
        <p className="text-foreground-500 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          加入91叔叔，发现更多精彩内容。无论是实用指南、优质资源还是会员专属权益，都在这里等你。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/guide"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            立即探索
          </Link>
          <Link
            to="/category/member"
            className="px-8 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            了解会员
          </Link>
        </div>
      </div>
    </section>
  );
}